import { __assign } from '../../_virtual/_tslib.js';
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import Tippy from '@tippyjs/react/headless';
import useBreakpoint from '../../hooks/useBreakpoint.js';
import 'react-scrolllock';
import upperFirst from 'lodash/upperFirst';
import elevationStyles from '../../elevations.css.js';
import '../Modals/Modal/index.js';
import FancyModal from '../Modals/FancyModal/index.js';
import '../Modals/SimpleModal/index.js';
import '../Modals/FancyModal/FancyShowcase/index.js';
import '../Modals/FancyModal/FancyContent/index.js';
import '../Modals/Components/ModalTitle/index.js';
import '../Modals/Components/ModalFooter/index.js';
import '../Modals/Components/ModalContent/index.js';
import styles from './styles.css.js';

/**
 * In Tippy, if visible = undefined it is shown on hover
 */

var Popover = function Popover(_a) {
  var children = _a.children,
      content = _a.content,
      visible = _a.visible,
      onRequestClose = _a.onRequestClose,
      _b = _a.placement,
      placement = _b === void 0 ? 'auto' : _b,
      _c = _a.variant,
      variant = _c === void 0 ? 'light' : _c,
      _d = _a.size,
      size = _d === void 0 ? 'small' : _d,
      _e = _a.interactive,
      interactive = _e === void 0 ? true : _e,
      _f = _a.hideArrow,
      hideArrow = _f === void 0 ? false : _f,
      appendTo = _a.appendTo,
      _g = _a.elevation,
      elevation = _g === void 0 ? 'lowest' : _g,
      wrapperClassName = _a.wrapperClassName;
  var isMobile = !useBreakpoint('sm');

  var _h = useState(false),
      isMounted = _h[0],
      setIsMounted = _h[1];

  var getZIndex = function getZIndex() {
    // Values should match those in elevations.css
    switch (elevation) {
      case 'lowest':
        return 10000000;

      case 'low':
        return 20000000;

      case 'mid':
        return 30000000;

      case 'high':
        return 40000000;

      case 'highest':
        return 50000000;

      default:
        return 10000000;
    }
  };

  useEffect(function () {
    setIsMounted(true);
  });

  if (isMobile) {
    return React.createElement(React.Fragment, null, React.createElement(FancyModal, {
      isOpen: visible || false,
      onRequestClose: onRequestClose,
      overlayClassName: elevationStyles["elevation" + upperFirst(elevation)]
    }, content), React.createElement("div", null, children));
  } else {
    // The Tippy renders itself to the end of the <body>, which can not be done during SSR.
    //
    // For Popovers rendered on SSR, we render only the children and rerender after mounting.
    if (!isMounted) {
      return React.createElement(React.Fragment, null, children);
    } // Using <span> is hack so that the child doesn't need to use React.forwardRef()


    return React.createElement(Tippy, {
      render: function render(attrs) {
        var _a;

        return React.createElement("div", __assign({}, attrs, {
          className: classnames(styles.popover, (_a = {}, _a[styles.light] = variant === 'light', _a[styles.dark] = variant === 'dark', _a[styles.small] = size === 'small', _a[styles.large] = size === 'large', _a))
        }), React.createElement("div", {
          className: styles.content
        }, content), !hideArrow && React.createElement("span", {
          "data-popper-arrow": "",
          className: styles.arrow
        }));
      },
      onClickOutside: function onClickOutside(_instance, e) {
        return onRequestClose && onRequestClose(e);
      },
      placement: placement,
      visible: visible,
      interactive: interactive,
      zIndex: getZIndex(),
      appendTo: appendTo || document.body
    }, React.createElement("span", {
      className: wrapperClassName
    }, children));
  }
};

export default Popover;
//# sourceMappingURL=index.js.map
